import routes from './routes';
import addHooks from './hooks';

export const addRoutesAndHooks = function (router) {
    router.addRoutes(routes);
    addHooks(router);
};

export default {
    addRoutesAndHooks
};
